import {Component} from '@angular/core';

@Component({
  selector: 'app-guest-main-page',
  templateUrl: './guest-main-page.component.html',
  styleUrl: './guest-main-page.component.scss'
})
export class GuestMainPageComponent {

}
